import { APP_NAMES } from 'config/urls';

const isMobileEvaluatorApp = () =>
  process.env.REACT_APP_NAME === APP_NAMES.MOBILE_EVALUATOR;

export default isMobileEvaluatorApp;
